class Permissions {
  constructor(appAPI, entitiesFormatter, requestsCache) {
    'ngInject';

    this.appAPI = appAPI;
    this.entitiesFormatter = entitiesFormatter;
    this.requestsCache = requestsCache;
  }
  loadAppRoles() {
    return this.requestsCache.save(
      'permissions.appRoles',
      () => this.appAPI.appRoles(),
    )
    .then((response) => response.permissions);
  }
  scopesWithPermissions(brandFacingOnly = false) {
    return this.requestsCache.save(
      brandFacingOnly ? 'permissions.brands' : 'permissions.all',
      () => this.appAPI.scopesWithPermissions(brandFacingOnly),
    );
  }
  scopes() {
    return this.requestsCache.save(
      'permissions.scopes',
      () => this.appAPI.scopes(),
    );
  }
  scope(scopeId) {
    return this.requestsCache.save(
      `permissions.scopes.${scopeId}`,
      () => this.appAPI.scope(scopeId),
    );
  }
  roles(scopeId) {
    return this.requestsCache.save(
      `permissions.roles.${scopeId}`,
      () => this.appAPI.roles(scopeId),
    );
  }
  role(roleId) {
    return this.requestsCache.save(
      `permissions.roles.${roleId}`,
      () => this.appAPI.role(roleId),
    );
  }
  save(userIds, brandIds, allowedIds, deniedIds, scopeId) {
    return this.appAPI.savePermissions(userIds, brandIds, allowedIds, deniedIds, scopeId);
  }
  revoke(userIds, brandIds, scopeId) {
    return this.appAPI.revokePermissions(userIds, brandIds, scopeId);
  }
  changeUserRole(userId, roleId) {
    return this.appAPI.changeUserRole(userId, roleId);
  }
}

export default Permissions;
